var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotConnectedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 121,
    viewBox: "0 0 215 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M117.601 51.7033C117.601 39.0253 123.466 27.5242 132.955 18.9153C130.978 9.26381 122.576 2 112.527 2C100.994 2 91.6362 11.5506 91.6362 23.3206C91.6362 23.6233 91.6362 23.9259 91.6692 24.2286C89.7581 23.6569 87.7482 23.3206 85.6723 23.3206C74.14 23.3206 64.7822 32.8712 64.7822 44.6413C53.2499 44.6413 43.8921 54.1918 43.8921 65.9619C43.8921 77.732 53.2499 87.2825 64.7822 87.2825H136.184C124.751 78.4718 117.535 65.8274 117.535 51.7706L117.601 51.7033Z",
    fill: "#CFEAF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.732 87.1418H162.897C174.691 87.1418 184.26 77.607 184.26 65.8563C184.26 54.1057 174.691 44.5709 162.897 44.5709C162.897 32.8203 153.328 23.2854 141.535 23.2854C139.412 23.2854 137.323 23.6212 135.403 24.1919C135.403 23.8898 135.436 23.5876 135.436 23.2854C135.436 11.5348 125.867 2 114.074 2C102.281 2 92.7113 11.5348 92.7113 23.2854C92.7113 23.5876 92.7113 23.8898 92.745 24.1919C90.7907 23.6212 88.7353 23.2854 86.6125 23.2854C74.8194 23.2854 65.2501 32.8203 65.2501 44.5709C53.4569 44.5709 43.8877 54.1057 43.8877 65.8563C43.8877 77.607 53.4569 87.1418 65.2501 87.1418",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.898 44.6045C162.898 32.8539 153.328 23.3191 141.535 23.3191C129.742 23.3191 120.173 32.8539 120.173 44.6045",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2837 44.6045H78.6144",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.284 56.7581C60.2298 56.7581 56.1191 60.854 56.1191 65.89C56.1191 70.926 60.2298 75.022 65.284 75.022",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.898 74.9883C167.952 74.9883 172.063 70.8924 172.063 65.8564C172.063 60.8204 167.952 56.7245 162.898 56.7245",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.465 78.8564L84.7379 92.5835C79.6837 97.6377 79.6837 105.832 84.7379 110.886C89.7921 115.941 97.9865 115.941 103.041 110.886L116.768 97.1592",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.763 60.8988L96.5278 49.1191",
    stroke: "#209DB2",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6015 70.0608L80.8218 64.8254",
    stroke: "#209DB2",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.323 105.4L130.558 117.18",
    stroke: "#209DB2",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134.485 96.238L146.265 101.473",
    stroke: "#209DB2",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126.244 87.6828L139.971 73.9555C145.026 68.9013 145.026 60.7069 139.971 55.6527C134.917 50.5985 126.723 50.5985 121.669 55.6527L107.941 69.3799",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.18 94.664L123.457 71.2697",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M182 111H187",
    stroke: "#CFEAF3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M191 111H208",
    stroke: "#CFEAF3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M195 117H186",
    stroke: "#CFEAF3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28 40H23",
    stroke: "#CFEAF3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19 40H2",
    stroke: "#CFEAF3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15 34H24",
    stroke: "#CFEAF3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M177 34H160",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M171.833 24.239C171.833 21.1171 170.307 18.2851 167.84 16.1652C168.354 13.7886 170.539 12 173.152 12C176.151 12 178.584 14.3517 178.584 17.25C178.584 17.3245 178.584 17.3991 178.576 17.4736C179.073 17.3328 179.596 17.25 180.135 17.25C183.134 17.25 185.568 19.6017 185.568 22.5C188.567 22.5 191 24.8517 191 27.75C191 30.6483 188.567 33 185.568 33H167C169.973 30.8304 171.85 27.7169 171.85 24.2555L171.833 24.239Z",
    fill: "#209DB2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M183.059 33.8305H185.748C188.783 33.8305 191.239 31.3254 191.239 28.2298C191.239 25.1342 188.783 22.6292 185.748 22.6292C185.748 19.5336 183.292 17.0285 180.257 17.0285C179.706 17.0285 179.174 17.1142 178.679 17.2666C178.679 17.1904 178.689 17.1047 178.689 17.0285C178.689 13.9329 176.233 11.4279 173.198 11.4279C170.163 11.4279 167.707 13.9329 167.707 17.0285C167.707 17.1047 167.707 17.1904 167.716 17.2666C167.212 17.1142 166.689 17.0285 166.138 17.0285C164.174 17.0285 162.452 18.0779 161.482 19.6576",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M43.852 41.9536C43.1228 40.549 41.9714 37.4878 40.5513 36.7665C41.9714 36.0452 43.1228 34.8936 43.852 33.5016C44.5812 34.9063 45.7454 36.0452 47.1527 36.7665C45.7326 37.4878 44.5812 40.5616 43.852 41.9536Z",
    fill: "#209DB2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4948 33.745C47.2069 33.745 44.5331 31.1002 44.5331 27.8479C44.5331 27.3796 44.1493 27 43.676 27C43.2026 27 42.8188 27.3796 42.8188 27.8479C42.8188 31.1002 40.145 33.745 36.8572 33.745C36.3838 33.745 36 34.1247 36 34.5929C36 35.0611 36.3838 35.4408 36.8572 35.4408C40.145 35.4408 42.8188 38.073 42.8188 41.3253C42.8188 41.7935 43.2026 42.1731 43.676 42.1731C44.1493 42.1731 44.5331 41.7935 44.5331 41.3253C44.5331 38.073 47.2069 35.4281 50.4948 35.4281C50.9681 35.4281 51.3519 35.0485 51.3519 34.5802C51.3519 34.112 50.9681 33.7324 50.4948 33.7324V33.745Z",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 104.572H40",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.1674 94.8111C22.1674 91.6893 23.6926 88.8572 26.1603 86.7374C25.6462 84.3608 23.4613 82.5721 20.8479 82.5721C17.849 82.5721 15.4156 84.9239 15.4156 87.8221C15.4156 87.8967 15.4156 87.9712 15.4241 88.0457C14.9272 87.905 14.4045 87.8221 13.8647 87.8221C10.8658 87.8221 8.43235 90.1739 8.43235 93.0721C5.43342 93.0721 3 95.4239 3 98.3221C3 101.22 5.43342 103.572 8.43235 103.572H27C24.0268 101.403 22.1503 98.289 22.1503 94.8277L22.1674 94.8111Z",
    fill: "#209DB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9411 104.403H8.25167C5.21671 104.403 2.76074 101.898 2.76074 98.8019C2.76074 95.7064 5.21671 93.2013 8.25167 93.2013C8.25167 90.1057 10.7076 87.6006 13.7426 87.6006C14.2935 87.6006 14.8258 87.6864 15.3207 87.8388C15.3207 87.7626 15.3114 87.6768 15.3114 87.6006C15.3114 84.5051 17.7674 82 20.8023 82C23.8373 82 26.2932 84.5051 26.2932 87.6006C26.2932 87.6768 26.2932 87.7626 26.2839 87.8388C26.7882 87.6864 27.3111 87.6006 27.8621 87.6006C29.8264 87.6006 31.5482 88.65 32.5185 90.2297",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M208.982 66.4875C208.519 65.5963 207.788 63.6542 206.888 63.1965C207.788 62.7388 208.519 62.0082 208.982 61.125C209.444 62.0162 210.183 62.7388 211.076 63.1965C210.175 63.6542 209.444 65.6044 208.982 66.4875Z",
    fill: "#CFEAF3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M213.196 61.2795C211.11 61.2795 209.414 59.6014 209.414 57.5379C209.414 57.2409 209.17 57 208.87 57C208.57 57 208.326 57.2409 208.326 57.5379C208.326 59.6014 206.63 61.2795 204.544 61.2795C204.244 61.2795 204 61.5203 204 61.8174C204 62.1145 204.244 62.3554 204.544 62.3554C206.63 62.3554 208.326 64.0254 208.326 66.0889C208.326 66.3859 208.57 66.6268 208.87 66.6268C209.17 66.6268 209.414 66.3859 209.414 66.0889C209.414 64.0254 211.11 62.3473 213.196 62.3473C213.497 62.3473 213.74 62.1065 213.74 61.8094C213.74 61.5123 213.497 61.2714 213.196 61.2714V61.2795Z",
    fill: "#CFEAF3",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M197 27H184",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M204 27H201",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M170.937 113.116C170.2 111.696 169.036 108.602 167.6 107.872C169.036 107.143 170.2 105.979 170.937 104.572C171.674 105.992 172.851 107.143 174.273 107.872C172.838 108.602 171.674 111.709 170.937 113.116Z",
    fill: "#209DB2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M177.652 104.818C174.328 104.818 171.626 102.145 171.626 98.8571C171.626 98.3838 171.238 98 170.759 98C170.281 98 169.893 98.3838 169.893 98.8571C169.893 102.145 167.19 104.818 163.866 104.818C163.388 104.818 163 105.202 163 105.675C163 106.148 163.388 106.532 163.866 106.532C167.19 106.532 169.893 109.193 169.893 112.481C169.893 112.954 170.281 113.338 170.759 113.338C171.238 113.338 171.626 112.954 171.626 112.481C171.626 109.193 174.328 106.519 177.652 106.519C178.13 106.519 178.518 106.136 178.518 105.662C178.518 105.189 178.13 104.805 177.652 104.805V104.818Z",
    stroke: "#063649",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97H58",
    stroke: "#CFEAF3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47 102H66",
    stroke: "#CFEAF3",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotConnectedIcon);
export default __webpack_public_path__ + "static/media/not_connected_icon.93860706aa38598edc1c9efe8431488f.svg";
export { ForwardRef as ReactComponent };